const preUrl = process.env.REACT_APP_NODE_ENV === 'dev' ? 'dev-swasth-help.netlify.app' : 'help.swasth.co';
export const helpConfig = {
  "/app/homework" : `https://${preUrl}/topics/assign-homework`,
  "/app/homework-list": `https://${preUrl}/topics/view-homework`,
  "/app/act-coach":`https://${preUrl}/topics/invite-clients-to-share-data`,
  "/app/dbt-coach":`https://${preUrl}/topics/invite-clients-to-share-data`,
  "/app/cbt-companion":`https://${preUrl}/topics/invite-clients-to-share-data`,
  "/app/dbt-daily":`https://${preUrl}/topics/invite-clients-to-share-data`,
  "/app/subscription":'',
  "/app/groups":`https://${preUrl}/categories/clinician-tools`,
  "/app/assessments/config  ":`https://${preUrl}/topics/assessments/`,
  "/app/assessments":"",
  "/app/assessments/population":"",
  "/app/coverage":"",
  "/app/appointment":`https://${preUrl}/topics/scheduling-editing-and-deleting-appointments/`,
  "/app/appointment-status":"",
  "/app/communication":"",
  "/app/clients":`https://${preUrl}/topics/adding-a-new-client`,
  "/app/billings": "",
  "/app/billings/insurance_payments/new":"",
  "/app/account-activity":"",
  "/app/insights":"",
  "/app/settings/practice-details":"",
  "/app/settings/billing-and-service":"",
  "/app/settings/documents":"",
  "/app/settings/notifications":"",
  "/app/settings/notesAndForms":"",
  "/app/settings/client-portal":"",
  "/app/settings/insurance-payer":"",
  "/app/team_members":"",
  "/app/profile":"",
};

export const videoConfig = {
  "/app/appointment":"Appointment",
};